/* eslint-disable */
/*
 *  DO NOT MODIFY THIS FILE
 *
 *  This file is autogenerated from db schema using the script codegen-domain-types.ts
 *  Any changes will be overwritten on next run
 */
import { msse, msseDate, numStr, posIntStr } from "@agrigate/ts-utils/lib/zod";
import * as z from "zod/v4";
import * as enums from "./enums";
import * as structs from "./structs";
// Enums and structs remain centralized in domain module
export * from "./enums";
export * from "./structs";
export const FinImportPurchase = z.object({
    ctExtId: z.string(),
    ctYear: z.number(),
    ctMonth: z.number(),
    ctDay: z.number(),
    cpName: z.string().nullish(),
    inventoryAmount: numStr,
    handlingCharges: numStr.nullish(),
    totalPurchaseAmount: numStr,
    purchaseEmployee: z.string().nullish(),
    cpState: z.string().nullish(),
});
export const NewFinImportPurchase = z.object({
    ctExtId: z.string(),
    ctYear: z.number(),
    ctMonth: z.number(),
    ctDay: z.number(),
    cpName: z.string().nullish(),
    inventoryAmount: numStr,
    handlingCharges: numStr.nullish(),
    totalPurchaseAmount: numStr,
    purchaseEmployee: z.string().nullish(),
    cpState: z.string().nullish(),
});
export const FinImportPurchaseUpdate = z
    .object({
    ctExtId: z.string(),
    ctYear: z.number(),
    ctMonth: z.number(),
    ctDay: z.number(),
    cpName: z.string().nullish(),
    inventoryAmount: numStr,
    handlingCharges: numStr.nullish(),
    totalPurchaseAmount: numStr,
    purchaseEmployee: z.string().nullish(),
    cpState: z.string().nullish(),
})
    .partial();
export const FinImportPurchaseSale = z.object({
    ctYear: z.number(),
    ctMonth: z.number(),
    ctExtId: z.string(),
    boExtId: z.string(),
});
export const NewFinImportPurchaseSale = z.object({
    ctYear: z.number(),
    ctMonth: z.number(),
    ctExtId: z.string(),
    boExtId: z.string(),
});
export const FinImportPurchaseSaleUpdate = z
    .object({
    ctYear: z.number(),
    ctMonth: z.number(),
    ctExtId: z.string(),
    boExtId: z.string(),
})
    .partial();
export const FinImportSale = z.object({
    boExtId: z.string(),
    boInvoiceDate: msse,
    buyerName: z.string(),
    saleAmount: numStr.nullish(),
    transportationOnSale: z.string().nullish(),
    handlingCharges: numStr.nullish(),
    finalSaleAmount: numStr.nullish(),
    cnNo: z.string().nullish(),
    cnAmount: numStr.nullish(),
    totalSaleAmount: numStr.nullish(),
    category: z.string().nullish(),
});
export const NewFinImportSale = z.object({
    boExtId: z.string(),
    boInvoiceDate: msseDate,
    buyerName: z.string(),
    saleAmount: numStr.nullish(),
    transportationOnSale: z.string().nullish(),
    handlingCharges: numStr.nullish(),
    finalSaleAmount: numStr.nullish(),
    cnNo: z.string().nullish(),
    cnAmount: numStr.nullish(),
    totalSaleAmount: numStr.nullish(),
    category: z.string().nullish(),
});
export const FinImportSaleUpdate = z
    .object({
    boExtId: z.string(),
    boInvoiceDate: msseDate,
    buyerName: z.string(),
    saleAmount: numStr.nullish(),
    transportationOnSale: z.string().nullish(),
    handlingCharges: numStr.nullish(),
    finalSaleAmount: numStr.nullish(),
    cnNo: z.string().nullish(),
    cnAmount: numStr.nullish(),
    totalSaleAmount: numStr.nullish(),
    category: z.string().nullish(),
})
    .partial();
export const ApiKey = z.object({
    userId: posIntStr,
    key: z.string(),
    type: enums.APIKeyType,
});
export const NewApiKey = z.object({
    userId: posIntStr,
    key: z.string(),
    type: enums.APIKeyType,
});
export const ApiKeyUpdate = z
    .object({
    userId: posIntStr,
    key: z.string(),
    type: enums.APIKeyType,
})
    .partial();
export const ApmcLicense = z.object({
    regionId: posIntStr.nullish(),
    licenseNo: z.string(),
});
export const NewApmcLicense = z.object({
    regionId: posIntStr.nullish(),
    licenseNo: z.string(),
});
export const ApmcLicenseUpdate = z
    .object({
    regionId: posIntStr.nullish(),
    licenseNo: z.string(),
})
    .partial();
export const AppInstallationToken = z.object({
    userId: posIntStr.nullish(),
    installationId: z.string().nullish(),
    appType: enums.AppType.nullish(),
    registeredAt: msse.nullish(),
    lastUsedAt: msse.nullish(),
});
export const NewAppInstallationToken = z.object({
    userId: posIntStr.nullish(),
    installationId: z.string().nullish(),
    appType: enums.AppType.nullish(),
    registeredAt: msseDate.nullish(),
    lastUsedAt: msseDate.nullish(),
});
export const AppInstallationTokenUpdate = z
    .object({
    userId: posIntStr.nullish(),
    installationId: z.string().nullish(),
    appType: enums.AppType.nullish(),
    registeredAt: msseDate.nullish(),
    lastUsedAt: msseDate.nullish(),
})
    .partial();
export const Bid = z.object({
    id: posIntStr,
    produceBatchId: posIntStr,
    bidderId: posIntStr,
    submittedAt: msse,
    listingApprovalStatus: enums.ApprovalStatus,
    listingStatus: enums.ListingStatus,
    acceptanceStatus: enums.ApprovalStatus,
    concludedAt: msse.nullish(),
    concluderId: posIntStr.nullish(),
    volumePercent: numStr,
    pubId: z.string().nullish(),
    buyerOrderId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    expiresAt: msse.nullish(),
});
export const NewBid = z.object({
    produceBatchId: posIntStr,
    bidderId: posIntStr,
    submittedAt: msseDate.nullish(),
    listingApprovalStatus: enums.ApprovalStatus.nullish(),
    listingStatus: enums.ListingStatus.nullish(),
    acceptanceStatus: enums.ApprovalStatus.nullish(),
    concludedAt: msseDate.nullish(),
    concluderId: posIntStr.nullish(),
    volumePercent: numStr,
    pubId: z.string().nullish(),
    buyerOrderId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    expiresAt: msseDate.nullish(),
});
export const BidUpdate = z
    .object({
    produceBatchId: posIntStr,
    bidderId: posIntStr,
    submittedAt: msseDate,
    listingApprovalStatus: enums.ApprovalStatus,
    listingStatus: enums.ListingStatus,
    acceptanceStatus: enums.ApprovalStatus,
    concludedAt: msseDate.nullish(),
    concluderId: posIntStr.nullish(),
    volumePercent: numStr,
    pubId: z.string().nullish(),
    buyerOrderId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    expiresAt: msseDate.nullish(),
})
    .partial();
export const ChannelPartner = z.object({
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    fullName: z.string().nullish(),
    profileApprovalStatus: enums.ApprovalStatus.nullish(),
    ccName: z.string().nullish(),
    ccId: posIntStr.nullish(),
    ccApprovalStatus: enums.ApprovalStatus.nullish(),
    clusterName: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    regionName: z.string().nullish(),
    regionId: posIntStr.nullish(),
});
export const NewChannelPartner = z.object({
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    fullName: z.string().nullish(),
    profileApprovalStatus: enums.ApprovalStatus.nullish(),
    ccName: z.string().nullish(),
    ccId: posIntStr.nullish(),
    ccApprovalStatus: enums.ApprovalStatus.nullish(),
    clusterName: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    regionName: z.string().nullish(),
    regionId: posIntStr.nullish(),
});
export const ChannelPartnerUpdate = z
    .object({
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    fullName: z.string().nullish(),
    profileApprovalStatus: enums.ApprovalStatus.nullish(),
    ccName: z.string().nullish(),
    ccId: posIntStr.nullish(),
    ccApprovalStatus: enums.ApprovalStatus.nullish(),
    clusterName: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    regionName: z.string().nullish(),
    regionId: posIntStr.nullish(),
})
    .partial();
export const CpIncentiveActivityType = z.object({
    code: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    supportedRateTypes: z.string().array(),
    isActive: z.boolean(),
});
export const NewCpIncentiveActivityType = z.object({
    code: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    supportedRateTypes: z.string().array().nullish(),
    isActive: z.boolean().nullish(),
});
export const CpIncentiveActivityTypeUpdate = z
    .object({
    code: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    supportedRateTypes: z.string().array(),
    isActive: z.boolean(),
})
    .partial();
export const CpIncentiveConfig = z.object({
    id: posIntStr,
    activityCode: z.string(),
    rateType: z.string(),
    rateValue: numStr,
    regionId: posIntStr.nullish(),
    collectionCenterId: posIntStr.nullish(),
    cpUserId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    minDelayDays: z.number().nullish(),
    isActive: z.boolean(),
    createdBy: posIntStr.nullish(),
    updatedBy: posIntStr.nullish(),
    createdAt: msse,
    updatedAt: msse,
});
export const NewCpIncentiveConfig = z.object({
    activityCode: z.string(),
    rateType: z.string(),
    rateValue: numStr,
    regionId: posIntStr.nullish(),
    collectionCenterId: posIntStr.nullish(),
    cpUserId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    minDelayDays: z.number().nullish(),
    isActive: z.boolean().nullish(),
    createdBy: posIntStr.nullish(),
    updatedBy: posIntStr.nullish(),
    createdAt: msseDate.nullish(),
});
export const CpIncentiveConfigUpdate = z
    .object({
    activityCode: z.string(),
    rateType: z.string(),
    rateValue: numStr,
    regionId: posIntStr.nullish(),
    collectionCenterId: posIntStr.nullish(),
    cpUserId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    minDelayDays: z.number().nullish(),
    isActive: z.boolean(),
    createdBy: posIntStr.nullish(),
    updatedBy: posIntStr.nullish(),
    createdAt: msseDate,
})
    .partial();
export const DeliveryPartner = z.object({
    id: posIntStr,
    name: z.string(),
});
export const NewDeliveryPartner = z.object({
    name: z.string(),
});
export const DeliveryPartnerUpdate = z
    .object({
    name: z.string(),
})
    .partial();
export const DeliveryPartnerMember = z.object({
    deliveryPartnerId: posIntStr,
    memberId: posIntStr,
});
export const NewDeliveryPartnerMember = z.object({
    deliveryPartnerId: posIntStr,
    memberId: posIntStr,
});
export const DeliveryPartnerMemberUpdate = z
    .object({
    deliveryPartnerId: posIntStr,
    memberId: posIntStr,
})
    .partial();
export const DemandSpeculation = z.object({
    id: posIntStr,
    creatorId: posIntStr.nullish(),
    submittedAt: msse,
    startAt: msse,
    endAt: msse,
    minAmount: numStr.nullish(),
    maxAmount: numStr.nullish(),
    geoScope: z.any().nullish(),
    ownerId: posIntStr.nullish(),
});
export const NewDemandSpeculation = z.object({
    creatorId: posIntStr.nullish(),
    submittedAt: msseDate,
    startAt: msseDate,
    endAt: msseDate,
    minAmount: numStr.nullish(),
    maxAmount: numStr.nullish(),
    geoScope: z.any().nullish(),
    ownerId: posIntStr.nullish(),
});
export const DemandSpeculationUpdate = z
    .object({
    creatorId: posIntStr.nullish(),
    submittedAt: msseDate,
    startAt: msseDate,
    endAt: msseDate,
    minAmount: numStr.nullish(),
    maxAmount: numStr.nullish(),
    geoScope: z.any().nullish(),
    ownerId: posIntStr.nullish(),
})
    .partial();
export const DocumentUpload = z.object({
    id: posIntStr,
    docId: z.string().nullish(),
    category: enums.DocumentCategory.nullish(),
    metadata: z.any().nullish(),
    keyPath: z.string().nullish(),
    creatorId: posIntStr.nullish(),
    approverId: posIntStr.nullish(),
    approvalStatus: enums.ApprovalStatus,
    rejectionReasonCode: z.string().nullish(),
    updatedAt: msse,
    createdAt: msse.nullish(),
    confirmedAt: msse.nullish(),
    issueDescription: z.string().nullish(),
});
export const NewDocumentUpload = z.object({
    docId: z.string().nullish(),
    category: enums.DocumentCategory.nullish(),
    metadata: z.any().nullish(),
    keyPath: z.string().nullish(),
    creatorId: posIntStr.nullish(),
    approverId: posIntStr.nullish(),
    approvalStatus: enums.ApprovalStatus.nullish(),
    rejectionReasonCode: z.string().nullish(),
    createdAt: msseDate.nullish(),
    confirmedAt: msseDate.nullish(),
    issueDescription: z.string().nullish(),
});
export const DocumentUploadUpdate = z
    .object({
    docId: z.string().nullish(),
    category: enums.DocumentCategory.nullish(),
    metadata: z.any().nullish(),
    keyPath: z.string().nullish(),
    creatorId: posIntStr.nullish(),
    approverId: posIntStr.nullish(),
    approvalStatus: enums.ApprovalStatus,
    rejectionReasonCode: z.string().nullish(),
    createdAt: msseDate.nullish(),
    confirmedAt: msseDate.nullish(),
    issueDescription: z.string().nullish(),
})
    .partial();
export const EmployeeTrack = z.object({
    id: posIntStr,
    employeeId: posIntStr,
    date: msse,
    distanceKms: z.number().nullish(),
    trackKeys: structs.EmployeeTrackKeys.nullish(),
    startedAt: msse.nullish(),
    endedAt: msse.nullish(),
});
export const NewEmployeeTrack = z.object({
    employeeId: posIntStr,
    date: msseDate,
    distanceKms: z.number().nullish(),
    trackKeys: structs.EmployeeTrackKeys.nullish(),
    startedAt: msseDate.nullish(),
    endedAt: msseDate.nullish(),
});
export const EmployeeTrackUpdate = z
    .object({
    employeeId: posIntStr,
    date: msseDate,
    distanceKms: z.number().nullish(),
    trackKeys: structs.EmployeeTrackKeys.nullish(),
    startedAt: msseDate.nullish(),
    endedAt: msseDate.nullish(),
})
    .partial();
export const ExternalDump = z.object({
    vendorId: z.string(),
    entityType: z.string(),
    entityId: z.string(),
    dumpedAt: msse.nullish(),
    keyPath: z.string().nullish(),
    createdAt: msse,
    contentType: z.string(),
    id: posIntStr,
    accessCode: z.string().nullish(),
});
export const NewExternalDump = z.object({
    vendorId: z.string(),
    entityType: z.string(),
    entityId: z.string(),
    dumpedAt: msseDate.nullish(),
    keyPath: z.string().nullish(),
    createdAt: msseDate.nullish(),
    contentType: z.string().nullish(),
    accessCode: z.string().nullish(),
});
export const ExternalDumpUpdate = z
    .object({
    vendorId: z.string(),
    entityType: z.string(),
    entityId: z.string(),
    dumpedAt: msseDate.nullish(),
    keyPath: z.string().nullish(),
    createdAt: msseDate,
    contentType: z.string(),
    accessCode: z.string().nullish(),
})
    .partial();
export const FinanceOrderImport = z.object({
    ctExtId: z.string().nullish(),
    ctDate: msse.nullish(),
    cpName: z.string().nullish(),
    inventoryAmount: numStr.nullish(),
    handlingCharges: numStr.nullish(),
    totalPurchaseAmount: numStr.nullish(),
    purchaseEmployee: z.string().nullish(),
    cpState: z.string().nullish(),
    boExtId: z.string().nullish(),
    boInvoiceDate: msse.nullish(),
    buyerName: z.string().nullish(),
    saleAmount: numStr.nullish(),
    transportationOnSale: z.string().nullish(),
    finalSaleAmount: numStr.nullish(),
    transportationExpense: numStr.nullish(),
    totalSaleAmount: numStr.nullish(),
    category: z.string().nullish(),
    pnl: numStr.nullish(),
});
export const NewFinanceOrderImport = z.object({
    ctExtId: z.string().nullish(),
    ctDate: msseDate.nullish(),
    cpName: z.string().nullish(),
    inventoryAmount: numStr.nullish(),
    handlingCharges: numStr.nullish(),
    totalPurchaseAmount: numStr.nullish(),
    purchaseEmployee: z.string().nullish(),
    cpState: z.string().nullish(),
    boExtId: z.string().nullish(),
    boInvoiceDate: msseDate.nullish(),
    buyerName: z.string().nullish(),
    saleAmount: numStr.nullish(),
    transportationOnSale: z.string().nullish(),
    finalSaleAmount: numStr.nullish(),
    transportationExpense: numStr.nullish(),
    totalSaleAmount: numStr.nullish(),
    category: z.string().nullish(),
    pnl: numStr.nullish(),
});
export const FinanceOrderImportUpdate = z
    .object({
    ctExtId: z.string().nullish(),
    ctDate: msseDate.nullish(),
    cpName: z.string().nullish(),
    inventoryAmount: numStr.nullish(),
    handlingCharges: numStr.nullish(),
    totalPurchaseAmount: numStr.nullish(),
    purchaseEmployee: z.string().nullish(),
    cpState: z.string().nullish(),
    boExtId: z.string().nullish(),
    boInvoiceDate: msseDate.nullish(),
    buyerName: z.string().nullish(),
    saleAmount: numStr.nullish(),
    transportationOnSale: z.string().nullish(),
    finalSaleAmount: numStr.nullish(),
    transportationExpense: numStr.nullish(),
    totalSaleAmount: numStr.nullish(),
    category: z.string().nullish(),
    pnl: numStr.nullish(),
})
    .partial();
export const Link = z.object({
    code: z.string(),
    url: z.string(),
});
export const NewLink = z.object({
    code: z.string(),
    url: z.string(),
});
export const LinkUpdate = z
    .object({
    code: z.string(),
    url: z.string(),
})
    .partial();
export const ManuallyPatchedMigration = z.object({
    version: z.string(),
    executedAt: msse,
});
export const NewManuallyPatchedMigration = z.object({
    version: z.string(),
    executedAt: msseDate,
});
export const ManuallyPatchedMigrationUpdate = z
    .object({
    version: z.string(),
    executedAt: msseDate,
})
    .partial();
export const Market = z.object({
    id: posIntStr,
    name: z.string(),
    clusterId: posIntStr.nullish(),
    state: z.string().nullish(),
    district: z.string().nullish(),
    cityOrVillage: z.string().nullish(),
});
export const NewMarket = z.object({
    name: z.string(),
    clusterId: posIntStr.nullish(),
    state: z.string().nullish(),
    district: z.string().nullish(),
    cityOrVillage: z.string().nullish(),
});
export const MarketUpdate = z
    .object({
    name: z.string(),
    clusterId: posIntStr.nullish(),
    state: z.string().nullish(),
    district: z.string().nullish(),
    cityOrVillage: z.string().nullish(),
})
    .partial();
export const MarketPrice = z.object({
    id: posIntStr,
    priceAt: msse,
    registeredAt: msse,
    amountPerKg: numStr.nullish(),
    amountPerBatch: numStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    varietyId: posIntStr.nullish(),
    produceName: z.string().nullish(),
    marketId: posIntStr,
});
export const NewMarketPrice = z.object({
    priceAt: msseDate,
    registeredAt: msseDate,
    amountPerKg: numStr.nullish(),
    amountPerBatch: numStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    varietyId: posIntStr.nullish(),
    produceName: z.string().nullish(),
    marketId: posIntStr,
});
export const MarketPriceUpdate = z
    .object({
    priceAt: msseDate,
    registeredAt: msseDate,
    amountPerKg: numStr.nullish(),
    amountPerBatch: numStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    varietyId: posIntStr.nullish(),
    produceName: z.string().nullish(),
    marketId: posIntStr,
})
    .partial();
export const Pgmigrations = z.object({
    id: z.number(),
    name: z.string(),
    runOn: msse,
});
export const NewPgmigrations = z.object({
    name: z.string(),
    runOn: msseDate,
});
export const PgmigrationsUpdate = z
    .object({
    name: z.string(),
    runOn: msseDate,
})
    .partial();
export const SearchTag = z.object({
    id: posIntStr,
    value: z.any(),
    originalLocaleCode: z.string(),
});
export const NewSearchTag = z.object({
    value: z.any(),
    originalLocaleCode: z.string(),
});
export const SearchTagUpdate = z
    .object({
    value: z.any(),
    originalLocaleCode: z.string(),
})
    .partial();
export const SellerOrder = z.object({
    id: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    listingApprovalStatus: enums.ApprovalStatus.nullish(),
    listedAt: msse.nullish(),
    delistedAt: msse.nullish(),
    delistingReason: enums.PBDelistingReason.nullish(),
    submittedAt: msse.nullish(),
    ingressAt: msse.nullish(),
    props: z.any().nullish(),
    pubId: z.string().nullish(),
    didRequestTransportation: z.boolean().nullish(),
    varietyId: posIntStr.nullish(),
    pointOfContactId: posIntStr.nullish(),
    managerId: posIntStr.nullish(),
    settledAt: msse.nullish(),
    collectionStopId: posIntStr.nullish(),
    isTemplate: z.boolean().nullish(),
    status: enums.PBStatus.nullish(),
    actionPending: z.boolean().nullish(),
    listingStatus: enums.ListingStatus.nullish(),
    templateGroupIdHash: z.string().nullish(),
    isTest: z.boolean().nullish(),
    importedAt: msse.nullish(),
    expectedIngressSlotStart: msse.nullish(),
    expectedIngressSlotDurationMins: z.number().nullish(),
    ingressStatus: enums.TransitStatus.nullish(),
    procurerId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    regionId: posIntStr.nullish(),
});
export const NewSellerOrder = z.object({
    produceTypeId: posIntStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    listingApprovalStatus: enums.ApprovalStatus.nullish(),
    listedAt: msseDate.nullish(),
    delistedAt: msseDate.nullish(),
    delistingReason: enums.PBDelistingReason.nullish(),
    submittedAt: msseDate.nullish(),
    ingressAt: msseDate.nullish(),
    props: z.any().nullish(),
    pubId: z.string().nullish(),
    didRequestTransportation: z.boolean().nullish(),
    varietyId: posIntStr.nullish(),
    pointOfContactId: posIntStr.nullish(),
    managerId: posIntStr.nullish(),
    settledAt: msseDate.nullish(),
    collectionStopId: posIntStr.nullish(),
    isTemplate: z.boolean().nullish(),
    status: enums.PBStatus.nullish(),
    actionPending: z.boolean().nullish(),
    listingStatus: enums.ListingStatus.nullish(),
    templateGroupIdHash: z.string().nullish(),
    isTest: z.boolean().nullish(),
    importedAt: msseDate.nullish(),
    expectedIngressSlotStart: msseDate.nullish(),
    expectedIngressSlotDurationMins: z.number().nullish(),
    ingressStatus: enums.TransitStatus.nullish(),
    procurerId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    regionId: posIntStr.nullish(),
});
export const SellerOrderUpdate = z
    .object({
    produceTypeId: posIntStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    listingApprovalStatus: enums.ApprovalStatus.nullish(),
    listedAt: msseDate.nullish(),
    delistedAt: msseDate.nullish(),
    delistingReason: enums.PBDelistingReason.nullish(),
    submittedAt: msseDate.nullish(),
    ingressAt: msseDate.nullish(),
    props: z.any().nullish(),
    pubId: z.string().nullish(),
    didRequestTransportation: z.boolean().nullish(),
    varietyId: posIntStr.nullish(),
    pointOfContactId: posIntStr.nullish(),
    managerId: posIntStr.nullish(),
    settledAt: msseDate.nullish(),
    collectionStopId: posIntStr.nullish(),
    isTemplate: z.boolean().nullish(),
    status: enums.PBStatus.nullish(),
    actionPending: z.boolean().nullish(),
    listingStatus: enums.ListingStatus.nullish(),
    templateGroupIdHash: z.string().nullish(),
    isTest: z.boolean().nullish(),
    importedAt: msseDate.nullish(),
    expectedIngressSlotStart: msseDate.nullish(),
    expectedIngressSlotDurationMins: z.number().nullish(),
    ingressStatus: enums.TransitStatus.nullish(),
    procurerId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    regionId: posIntStr.nullish(),
})
    .partial();
export const SellerOrderItem = z.object({
    id: posIntStr.nullish(),
    produceBatchId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    varietyId: posIntStr.nullish(),
    props: z.any().nullish(),
    numExpectedBatches: z.number().nullish(),
    batchSize: z.number().nullish(),
});
export const NewSellerOrderItem = z.object({
    produceBatchId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    varietyId: posIntStr.nullish(),
    props: z.any().nullish(),
    numExpectedBatches: z.number().nullish(),
    batchSize: z.number().nullish(),
});
export const SellerOrderItemUpdate = z
    .object({
    produceBatchId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    varietyId: posIntStr.nullish(),
    props: z.any().nullish(),
    numExpectedBatches: z.number().nullish(),
    batchSize: z.number().nullish(),
})
    .partial();
export const SellerSettlement = z.object({
    id: posIntStr.nullish(),
    bidId: posIntStr.nullish(),
    amount: numStr.nullish(),
    status: enums.TransactionStatus.nullish(),
    produceBatchId: posIntStr.nullish(),
    weightKg: numStr.nullish(),
    amountPerKg: numStr.nullish(),
    deductions: structs.SettlementDeductions.nullish(),
    createdAt: msse.nullish(),
    comments: z.string().nullish(),
    acceptanceReasonCode: enums.AcceptanceReasonCode.nullish(),
    paymentProvider: enums.PaymentProvider.nullish(),
    expiresAt: msse.nullish(),
    importContext: z.any().nullish(),
    concludedAt: msse.nullish(),
    collectionTargetId: posIntStr.nullish(),
});
export const NewSellerSettlement = z.object({
    bidId: posIntStr.nullish(),
    amount: numStr.nullish(),
    status: enums.TransactionStatus.nullish(),
    produceBatchId: posIntStr.nullish(),
    weightKg: numStr.nullish(),
    amountPerKg: numStr.nullish(),
    deductions: structs.SettlementDeductions.nullish(),
    createdAt: msseDate.nullish(),
    comments: z.string().nullish(),
    acceptanceReasonCode: enums.AcceptanceReasonCode.nullish(),
    paymentProvider: enums.PaymentProvider.nullish(),
    expiresAt: msseDate.nullish(),
    importContext: z.any().nullish(),
    concludedAt: msseDate.nullish(),
    collectionTargetId: posIntStr.nullish(),
});
export const SellerSettlementUpdate = z
    .object({
    bidId: posIntStr.nullish(),
    amount: numStr.nullish(),
    status: enums.TransactionStatus.nullish(),
    produceBatchId: posIntStr.nullish(),
    weightKg: numStr.nullish(),
    amountPerKg: numStr.nullish(),
    deductions: structs.SettlementDeductions.nullish(),
    createdAt: msseDate.nullish(),
    comments: z.string().nullish(),
    acceptanceReasonCode: enums.AcceptanceReasonCode.nullish(),
    paymentProvider: enums.PaymentProvider.nullish(),
    expiresAt: msseDate.nullish(),
    importContext: z.any().nullish(),
    concludedAt: msseDate.nullish(),
    collectionTargetId: posIntStr.nullish(),
})
    .partial();
export const SellerSettlementItem = z.object({
    itemId: posIntStr.nullish(),
    settlementId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    id: posIntStr.nullish(),
    offeredAt: msse.nullish(),
    acceptedAt: msse.nullish(),
    rejectedAt: msse.nullish(),
    amountPerBatch: numStr.nullish(),
    produceBatchId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    updatedAt: msse.nullish(),
    updaterId: posIntStr.nullish(),
    updateCause: z.string().nullish(),
    offeredWeightKg: numStr.nullish(),
    deliveredWeightKg: numStr.nullish(),
    offeredVarietyId: posIntStr.nullish(),
    deliveredVarietyId: posIntStr.nullish(),
    offeredNumBatches: z.number().nullish(),
    deliveredNumBatches: z.number().nullish(),
    weightKg: numStr.nullish(),
    varietyId: posIntStr.nullish(),
    numBatches: z.number().nullish(),
    amount: numStr.nullish(),
});
export const NewSellerSettlementItem = z.object({
    itemId: posIntStr.nullish(),
    settlementId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    offeredAt: msseDate.nullish(),
    acceptedAt: msseDate.nullish(),
    rejectedAt: msseDate.nullish(),
    amountPerBatch: numStr.nullish(),
    produceBatchId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    offeredWeightKg: numStr.nullish(),
    deliveredWeightKg: numStr.nullish(),
    offeredVarietyId: posIntStr.nullish(),
    deliveredVarietyId: posIntStr.nullish(),
    offeredNumBatches: z.number().nullish(),
    deliveredNumBatches: z.number().nullish(),
    weightKg: numStr.nullish(),
    varietyId: posIntStr.nullish(),
    numBatches: z.number().nullish(),
    amount: numStr.nullish(),
});
export const SellerSettlementItemUpdate = z
    .object({
    itemId: posIntStr.nullish(),
    settlementId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    offeredAt: msseDate.nullish(),
    acceptedAt: msseDate.nullish(),
    rejectedAt: msseDate.nullish(),
    amountPerBatch: numStr.nullish(),
    produceBatchId: posIntStr.nullish(),
    produceTypeId: posIntStr.nullish(),
    offeredWeightKg: numStr.nullish(),
    deliveredWeightKg: numStr.nullish(),
    offeredVarietyId: posIntStr.nullish(),
    deliveredVarietyId: posIntStr.nullish(),
    offeredNumBatches: z.number().nullish(),
    deliveredNumBatches: z.number().nullish(),
    weightKg: numStr.nullish(),
    varietyId: posIntStr.nullish(),
    numBatches: z.number().nullish(),
    amount: numStr.nullish(),
})
    .partial();
export const Stash = z.object({
    id: posIntStr,
    type: z.string(),
    content: z.any().nullish(),
    createdAt: msse.nullish(),
    updatedAt: msse.nullish(),
    subject: z.string().nullish(),
});
export const NewStash = z.object({
    type: z.string(),
    content: z.any().nullish(),
    createdAt: msseDate.nullish(),
    subject: z.string().nullish(),
});
export const StashUpdate = z
    .object({
    type: z.string(),
    content: z.any().nullish(),
    createdAt: msseDate.nullish(),
    subject: z.string().nullish(),
})
    .partial();
export const Vertical = z.object({
    id: posIntStr,
    name: z.string(),
    zohoTagId: z.string().nullish(),
});
export const NewVertical = z.object({
    name: z.string(),
    zohoTagId: z.string().nullish(),
});
export const VerticalUpdate = z
    .object({
    name: z.string(),
    zohoTagId: z.string().nullish(),
})
    .partial();
export const ReportingAiTokenUsage = z.object({
    id: posIntStr,
    usageDate: msse,
    modelId: z.string(),
    iamArn: z.string(),
    inputTokens: posIntStr,
    outputTokens: posIntStr,
    totalTokens: posIntStr,
    requestCount: posIntStr,
    createdAt: msse,
    updatedAt: msse,
});
export const NewReportingAiTokenUsage = z.object({
    usageDate: msseDate,
    modelId: z.string(),
    iamArn: z.string(),
    inputTokens: posIntStr.nullish(),
    outputTokens: posIntStr.nullish(),
    totalTokens: posIntStr.nullish(),
    requestCount: posIntStr.nullish(),
    createdAt: msseDate.nullish(),
});
export const ReportingAiTokenUsageUpdate = z
    .object({
    usageDate: msseDate,
    modelId: z.string(),
    iamArn: z.string(),
    inputTokens: posIntStr,
    outputTokens: posIntStr,
    totalTokens: posIntStr,
    requestCount: posIntStr,
    createdAt: msseDate,
})
    .partial();
export const ReportingAppDailyActiveVisitorCount = z.object({
    date: msse,
    visitorCount: z.number(),
    app: z.string(),
    granularity: z.string(),
});
export const NewReportingAppDailyActiveVisitorCount = z.object({
    date: msseDate,
    visitorCount: z.number(),
    app: z.string(),
    granularity: z.string(),
});
export const ReportingAppDailyActiveVisitorCountUpdate = z
    .object({
    date: msseDate,
    visitorCount: z.number(),
    app: z.string(),
    granularity: z.string(),
})
    .partial();
export const ReportingAppInstallation = z.object({
    userId: posIntStr,
    installationId: z.string(),
    registeredAt: msse,
    lastUsedAt: msse,
    peerCount: z.number(),
    prevCount: z.number(),
});
export const NewReportingAppInstallation = z.object({
    userId: posIntStr,
    installationId: z.string(),
    registeredAt: msseDate,
    lastUsedAt: msseDate,
    peerCount: z.number(),
    prevCount: z.number(),
});
export const ReportingAppInstallationUpdate = z
    .object({
    userId: posIntStr,
    installationId: z.string(),
    registeredAt: msseDate,
    lastUsedAt: msseDate,
    peerCount: z.number(),
    prevCount: z.number(),
})
    .partial();
export const ReportingAppVisitor = z.object({
    visitorId: posIntStr,
    appType: enums.AppType,
    date: msse,
    clusterName: z.string().nullish(),
    regionName: z.string().nullish(),
    blockName: z.string().nullish(),
    districtName: z.string().nullish(),
    visitorName: z.string().nullish(),
    visitorPubId: z.string().nullish(),
    timeSpent: z.number().nullish(),
});
export const NewReportingAppVisitor = z.object({
    visitorId: posIntStr,
    appType: enums.AppType,
    date: msseDate,
    clusterName: z.string().nullish(),
    regionName: z.string().nullish(),
    blockName: z.string().nullish(),
    districtName: z.string().nullish(),
    visitorName: z.string().nullish(),
    visitorPubId: z.string().nullish(),
    timeSpent: z.number().nullish(),
});
export const ReportingAppVisitorUpdate = z
    .object({
    visitorId: posIntStr,
    appType: enums.AppType,
    date: msseDate,
    clusterName: z.string().nullish(),
    regionName: z.string().nullish(),
    blockName: z.string().nullish(),
    districtName: z.string().nullish(),
    visitorName: z.string().nullish(),
    visitorPubId: z.string().nullish(),
    timeSpent: z.number().nullish(),
})
    .partial();
export const ReportingCtVisitor = z.object({
    collectionTargetId: posIntStr.nullish(),
    visitorId: posIntStr.nullish(),
    viewedAlertAt: msse.nullish(),
    clickedOrderAt: msse.nullish(),
    placedOrderAt: msse.nullish(),
    clusterName: z.string().nullish(),
    regionName: z.string().nullish(),
    blockName: z.string().nullish(),
    districtName: z.string().nullish(),
    visitorName: z.string().nullish(),
    visitorPubId: z.string().nullish(),
});
export const NewReportingCtVisitor = z.object({
    collectionTargetId: posIntStr.nullish(),
    visitorId: posIntStr.nullish(),
    viewedAlertAt: msseDate.nullish(),
    clickedOrderAt: msseDate.nullish(),
    placedOrderAt: msseDate.nullish(),
    clusterName: z.string().nullish(),
    regionName: z.string().nullish(),
    blockName: z.string().nullish(),
    districtName: z.string().nullish(),
    visitorName: z.string().nullish(),
    visitorPubId: z.string().nullish(),
});
export const ReportingCtVisitorUpdate = z
    .object({
    collectionTargetId: posIntStr.nullish(),
    visitorId: posIntStr.nullish(),
    viewedAlertAt: msseDate.nullish(),
    clickedOrderAt: msseDate.nullish(),
    placedOrderAt: msseDate.nullish(),
    clusterName: z.string().nullish(),
    regionName: z.string().nullish(),
    blockName: z.string().nullish(),
    districtName: z.string().nullish(),
    visitorName: z.string().nullish(),
    visitorPubId: z.string().nullish(),
})
    .partial();
export const ReportingEquipmentBookingDetails = z.object({
    bookingId: posIntStr,
    bookingPubId: z.string().nullish(),
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    machineId: posIntStr.nullish(),
    modelId: posIntStr.nullish(),
    categoryId: posIntStr.nullish(),
    categoryKey: z.string().nullish(),
    brandId: posIntStr.nullish(),
    brandKey: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    status: z.string().nullish(),
    slotDate: msse.nullish(),
    startTime: msse.nullish(),
    endTime: msse.nullish(),
    submittedAt: msse.nullish(),
    completedAt: msse.nullish(),
    amount: numStr.nullish(),
});
export const NewReportingEquipmentBookingDetails = z.object({
    bookingId: posIntStr,
    bookingPubId: z.string().nullish(),
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    machineId: posIntStr.nullish(),
    modelId: posIntStr.nullish(),
    categoryId: posIntStr.nullish(),
    categoryKey: z.string().nullish(),
    brandId: posIntStr.nullish(),
    brandKey: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    status: z.string().nullish(),
    slotDate: msseDate.nullish(),
    startTime: msseDate.nullish(),
    endTime: msseDate.nullish(),
    submittedAt: msseDate.nullish(),
    completedAt: msseDate.nullish(),
    amount: numStr.nullish(),
});
export const ReportingEquipmentBookingDetailsUpdate = z
    .object({
    bookingId: posIntStr,
    bookingPubId: z.string().nullish(),
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    machineId: posIntStr.nullish(),
    modelId: posIntStr.nullish(),
    categoryId: posIntStr.nullish(),
    categoryKey: z.string().nullish(),
    brandId: posIntStr.nullish(),
    brandKey: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    status: z.string().nullish(),
    slotDate: msseDate.nullish(),
    startTime: msseDate.nullish(),
    endTime: msseDate.nullish(),
    submittedAt: msseDate.nullish(),
    completedAt: msseDate.nullish(),
    amount: numStr.nullish(),
})
    .partial();
export const ReportingFeedItemVisits = z.object({
    feedItemId: posIntStr,
    viewCount: z.number(),
});
export const NewReportingFeedItemVisits = z.object({
    feedItemId: posIntStr,
    viewCount: z.number().nullish(),
});
export const ReportingFeedItemVisitsUpdate = z
    .object({
    feedItemId: posIntStr,
    viewCount: z.number(),
})
    .partial();
export const ReportingInsurancePremiumPayment = z.object({
    premiumId: posIntStr,
    userId: posIntStr,
    userFullName: z.string().nullish(),
    planId: z.string(),
    planKey: z.string(),
    categoryId: z.string(),
    categoryKey: z.string(),
    status: z.string(),
    confirmedAt: msse,
    applicationId: posIntStr,
    durationLabel: z.string(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    premiumAmount: numStr.nullish(),
    claimId: z.string().nullish(),
    claimInitiatedAt: msse.nullish(),
    claimSettledAt: msse.nullish(),
});
export const NewReportingInsurancePremiumPayment = z.object({
    premiumId: posIntStr,
    userId: posIntStr,
    userFullName: z.string().nullish(),
    planId: z.string(),
    planKey: z.string(),
    categoryId: z.string(),
    categoryKey: z.string(),
    status: z.string(),
    confirmedAt: msseDate,
    applicationId: posIntStr,
    durationLabel: z.string(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    premiumAmount: numStr.nullish(),
    claimId: z.string().nullish(),
    claimInitiatedAt: msseDate.nullish(),
    claimSettledAt: msseDate.nullish(),
});
export const ReportingInsurancePremiumPaymentUpdate = z
    .object({
    premiumId: posIntStr,
    userId: posIntStr,
    userFullName: z.string().nullish(),
    planId: z.string(),
    planKey: z.string(),
    categoryId: z.string(),
    categoryKey: z.string(),
    status: z.string(),
    confirmedAt: msseDate,
    applicationId: posIntStr,
    durationLabel: z.string(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    premiumAmount: numStr.nullish(),
    claimId: z.string().nullish(),
    claimInitiatedAt: msseDate.nullish(),
    claimSettledAt: msseDate.nullish(),
})
    .partial();
export const ReportingMarketplaceOrderDetails = z.object({
    orderId: posIntStr,
    amount: numStr,
    purchaserId: posIntStr,
    pickupSlot: msse.nullish(),
    externalId: z.string(),
    createdAt: msse,
    concludedAt: msse.nullish(),
    updatedAt: msse,
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
});
export const NewReportingMarketplaceOrderDetails = z.object({
    orderId: posIntStr,
    amount: numStr,
    purchaserId: posIntStr,
    pickupSlot: msseDate.nullish(),
    externalId: z.string(),
    createdAt: msseDate,
    concludedAt: msseDate.nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
});
export const ReportingMarketplaceOrderDetailsUpdate = z
    .object({
    orderId: posIntStr,
    amount: numStr,
    purchaserId: posIntStr,
    pickupSlot: msseDate.nullish(),
    externalId: z.string(),
    createdAt: msseDate,
    concludedAt: msseDate.nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
})
    .partial();
export const ReportingMarketplaceOrderItemDetails = z.object({
    orderItemId: posIntStr,
    orderId: posIntStr,
    skuId: posIntStr,
    skuName: z.string().nullish(),
    productId: posIntStr,
    productKey: z.string().nullish(),
    productName: z.string().nullish(),
    categoryId: posIntStr,
    categoryKey: z.string().nullish(),
    categoryName: z.string().nullish(),
    amount: numStr,
});
export const NewReportingMarketplaceOrderItemDetails = z.object({
    orderItemId: posIntStr,
    orderId: posIntStr,
    skuId: posIntStr,
    skuName: z.string().nullish(),
    productId: posIntStr,
    productKey: z.string().nullish(),
    productName: z.string().nullish(),
    categoryId: posIntStr,
    categoryKey: z.string().nullish(),
    categoryName: z.string().nullish(),
    amount: numStr,
});
export const ReportingMarketplaceOrderItemDetailsUpdate = z
    .object({
    orderItemId: posIntStr,
    orderId: posIntStr,
    skuId: posIntStr,
    skuName: z.string().nullish(),
    productId: posIntStr,
    productKey: z.string().nullish(),
    productName: z.string().nullish(),
    categoryId: posIntStr,
    categoryKey: z.string().nullish(),
    categoryName: z.string().nullish(),
    amount: numStr,
})
    .partial();
export const ReportingOrderDetails = z.object({
    settlementItemId: posIntStr,
    settlementId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    amountPerBatch: posIntStr.nullish(),
    weightKg: numStr.nullish(),
    numBatches: z.number().nullish(),
    userId: posIntStr.nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    romanizedState: z.string().nullish(),
    romanizedDistrict: z.string().nullish(),
    romanizedCityOrVillage: z.string().nullish(),
    pinCode: z.string().nullish(),
    produceTypeKey: z.string().nullish(),
    produceTypeName: z.string().nullish(),
    categoryKey: z.string().nullish(),
    categoryName: z.string().nullish(),
    orderType: enums.OrderType,
    submittedAt: msse.nullish(),
    listedAt: msse.nullish(),
    concludedAt: msse.nullish(),
    procurerId: posIntStr.nullish(),
    managerId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    clusterRegionId: posIntStr.nullish(),
    amount: numStr.nullish(),
    procurerFullName: z.string().nullish(),
    managerFullName: z.string().nullish(),
    perishability: z.string().nullish(),
    clusterName: z.string().nullish(),
    clusterRegionName: z.string().nullish(),
    marketProcured: z.boolean().nullish(),
    orderId: posIntStr.nullish(),
    orderPubId: z.string().nullish(),
    userPubId: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    procurerRole: z.string().nullish(),
    creditDurationDays: z.number().nullish(),
    payoutMode: z.string().nullish(),
    shipmentCount: z.number().nullish(),
});
export const NewReportingOrderDetails = z.object({
    settlementItemId: posIntStr,
    settlementId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    amountPerBatch: posIntStr.nullish(),
    weightKg: numStr.nullish(),
    numBatches: z.number().nullish(),
    userId: posIntStr.nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    romanizedState: z.string().nullish(),
    romanizedDistrict: z.string().nullish(),
    romanizedCityOrVillage: z.string().nullish(),
    pinCode: z.string().nullish(),
    produceTypeKey: z.string().nullish(),
    produceTypeName: z.string().nullish(),
    categoryKey: z.string().nullish(),
    categoryName: z.string().nullish(),
    orderType: enums.OrderType,
    submittedAt: msseDate.nullish(),
    listedAt: msseDate.nullish(),
    concludedAt: msseDate.nullish(),
    procurerId: posIntStr.nullish(),
    managerId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    clusterRegionId: posIntStr.nullish(),
    amount: numStr.nullish(),
    procurerFullName: z.string().nullish(),
    managerFullName: z.string().nullish(),
    perishability: z.string().nullish(),
    clusterName: z.string().nullish(),
    clusterRegionName: z.string().nullish(),
    marketProcured: z.boolean().nullish(),
    orderId: posIntStr.nullish(),
    orderPubId: z.string().nullish(),
    userPubId: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    procurerRole: z.string().nullish(),
    creditDurationDays: z.number().nullish(),
    payoutMode: z.string().nullish(),
    shipmentCount: z.number().nullish(),
});
export const ReportingOrderDetailsUpdate = z
    .object({
    settlementItemId: posIntStr,
    settlementId: posIntStr.nullish(),
    amountPerKg: numStr.nullish(),
    amountPerBatch: posIntStr.nullish(),
    weightKg: numStr.nullish(),
    numBatches: z.number().nullish(),
    userId: posIntStr.nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    romanizedState: z.string().nullish(),
    romanizedDistrict: z.string().nullish(),
    romanizedCityOrVillage: z.string().nullish(),
    pinCode: z.string().nullish(),
    produceTypeKey: z.string().nullish(),
    produceTypeName: z.string().nullish(),
    categoryKey: z.string().nullish(),
    categoryName: z.string().nullish(),
    orderType: enums.OrderType,
    submittedAt: msseDate.nullish(),
    listedAt: msseDate.nullish(),
    concludedAt: msseDate.nullish(),
    procurerId: posIntStr.nullish(),
    managerId: posIntStr.nullish(),
    clusterId: posIntStr.nullish(),
    clusterRegionId: posIntStr.nullish(),
    amount: numStr.nullish(),
    procurerFullName: z.string().nullish(),
    managerFullName: z.string().nullish(),
    perishability: z.string().nullish(),
    clusterName: z.string().nullish(),
    clusterRegionName: z.string().nullish(),
    marketProcured: z.boolean().nullish(),
    orderId: posIntStr.nullish(),
    orderPubId: z.string().nullish(),
    userPubId: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    procurerRole: z.string().nullish(),
    creditDurationDays: z.number().nullish(),
    payoutMode: z.string().nullish(),
    shipmentCount: z.number().nullish(),
})
    .partial();
export const ReportingOrderSettlements = z.object({
    buyerOrderId: posIntStr.nullish(),
    buyerSettlementId: posIntStr.nullish(),
    concludedAt: msse.nullish(),
    poIds: posIntStr.nullish(),
    clusterIds: posIntStr.nullish(),
    clusterRegionIds: posIntStr.nullish(),
    poAmount: numStr.nullish(),
    buyerSettlementAmount: numStr.nullish(),
    shipmentCost: numStr.nullish(),
    wastageCost: numStr.nullish(),
    buyerOrderExtId: z.string().nullish(),
    createdAt: msse.nullish(),
    updatedAt: msse.nullish(),
    poExtIds: z.string().nullish(),
    clusterNames: z.string().nullish(),
    procurerNames: z.string().nullish(),
    fulfillmentDurationHours: z.number().nullish(),
    expectedPaymentDurationHours: z.number().nullish(),
    actualPaymentDurationHours: z.number().nullish(),
    clusterDistrictIds: posIntStr.nullish(),
    clusterRegionNames: z.string().nullish(),
    clusterDistrictNames: z.string().nullish(),
    clusterBlockIds: posIntStr.nullish(),
    clusterBlockNames: z.string().nullish(),
    buyerTdsDeduction: numStr.nullish(),
    profit: numStr.nullish(),
    margin: numStr.nullish(),
});
export const NewReportingOrderSettlements = z.object({
    buyerOrderId: posIntStr.nullish(),
    buyerSettlementId: posIntStr.nullish(),
    concludedAt: msseDate.nullish(),
    poIds: posIntStr.nullish(),
    clusterIds: posIntStr.nullish(),
    clusterRegionIds: posIntStr.nullish(),
    poAmount: numStr.nullish(),
    buyerSettlementAmount: numStr.nullish(),
    shipmentCost: numStr.nullish(),
    wastageCost: numStr.nullish(),
    buyerOrderExtId: z.string().nullish(),
    createdAt: msseDate.nullish(),
    poExtIds: z.string().nullish(),
    clusterNames: z.string().nullish(),
    procurerNames: z.string().nullish(),
    fulfillmentDurationHours: z.number().nullish(),
    expectedPaymentDurationHours: z.number().nullish(),
    actualPaymentDurationHours: z.number().nullish(),
    clusterDistrictIds: posIntStr.nullish(),
    clusterRegionNames: z.string().nullish(),
    clusterDistrictNames: z.string().nullish(),
    clusterBlockIds: posIntStr.nullish(),
    clusterBlockNames: z.string().nullish(),
    buyerTdsDeduction: numStr.nullish(),
    profit: numStr.nullish(),
    margin: numStr.nullish(),
});
export const ReportingOrderSettlementsUpdate = z
    .object({
    buyerOrderId: posIntStr.nullish(),
    buyerSettlementId: posIntStr.nullish(),
    concludedAt: msseDate.nullish(),
    poIds: posIntStr.nullish(),
    clusterIds: posIntStr.nullish(),
    clusterRegionIds: posIntStr.nullish(),
    poAmount: numStr.nullish(),
    buyerSettlementAmount: numStr.nullish(),
    shipmentCost: numStr.nullish(),
    wastageCost: numStr.nullish(),
    buyerOrderExtId: z.string().nullish(),
    createdAt: msseDate.nullish(),
    poExtIds: z.string().nullish(),
    clusterNames: z.string().nullish(),
    procurerNames: z.string().nullish(),
    fulfillmentDurationHours: z.number().nullish(),
    expectedPaymentDurationHours: z.number().nullish(),
    actualPaymentDurationHours: z.number().nullish(),
    clusterDistrictIds: posIntStr.nullish(),
    clusterRegionNames: z.string().nullish(),
    clusterDistrictNames: z.string().nullish(),
    clusterBlockIds: posIntStr.nullish(),
    clusterBlockNames: z.string().nullish(),
    buyerTdsDeduction: numStr.nullish(),
    profit: numStr.nullish(),
    margin: numStr.nullish(),
})
    .partial();
export const ReportingShipmentDetails = z.object({
    shipmentId: posIntStr,
    expectedDispatchSlotStart: msse.nullish(),
    dispatchedAt: msse.nullish(),
    expectedToDeliverAt: msse.nullish(),
    deliveredAt: msse.nullish(),
    pubId: z.string().nullish(),
    createdAt: msse.nullish(),
    transitStatus: enums.TransitStatus.nullish(),
    legacyCost: numStr.nullish(),
    handlingCharge: z.string().nullish(),
    transportationCharge: z.string().nullish(),
    advanceAmount: z.string().nullish(),
    qualityCheckStatus: enums.QualityCheckStatus.nullish(),
    numBags: z.number().nullish(),
    avgPricePerBatch: numStr.nullish(),
    avgPricePerKg: numStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    numExpectedBatches: z.number().nullish(),
    batchSize: z.number().nullish(),
    weightDispatchedKg: numStr.nullish(),
    numBatchesDispatched: z.number().nullish(),
    weightDeliveredKg: numStr.nullish(),
    numBatchesDelivered: z.number().nullish(),
    produceTypeId: posIntStr.nullish(),
    produceTypeKey: z.string().nullish(),
    varietyId: posIntStr.nullish(),
    varietyKey: z.string().nullish(),
    ingressStopId: posIntStr.nullish(),
    ingressStopName: z.string().nullish(),
    ingressClusterId: posIntStr.nullish(),
    ingressClusterName: z.string().nullish(),
    ingressBlockId: posIntStr.nullish(),
    ingressBlockName: z.string().nullish(),
    ingressDistrictId: posIntStr.nullish(),
    ingressDistrictName: z.string().nullish(),
    ingressRegionId: posIntStr.nullish(),
    ingressRegionName: z.string().nullish(),
    buyerOrderId: posIntStr.nullish(),
    buyerOrderPubId: z.string().nullish(),
    buyerId: posIntStr.nullish(),
    buyerPubId: z.string().nullish(),
    buyerFullName: z.string().nullish(),
    deliveryAddressId: posIntStr.nullish(),
    cancellerId: posIntStr.nullish(),
    cancellerFullName: z.string().nullish(),
    vehicleOwnerId: posIntStr.nullish(),
    vehicleOwnerFullName: z.string().nullish(),
    vehicleDriverId: posIntStr.nullish(),
    vehicleDriverFullName: z.string().nullish(),
    transporterId: posIntStr.nullish(),
    transporterFullName: z.string().nullish(),
    qualityCheckerId: posIntStr.nullish(),
    qualityCheckerFullName: z.string().nullish(),
    shipmentItemId: posIntStr,
    amount: numStr.nullish(),
});
export const NewReportingShipmentDetails = z.object({
    shipmentId: posIntStr,
    expectedDispatchSlotStart: msseDate.nullish(),
    dispatchedAt: msseDate.nullish(),
    expectedToDeliverAt: msseDate.nullish(),
    deliveredAt: msseDate.nullish(),
    pubId: z.string().nullish(),
    createdAt: msseDate.nullish(),
    transitStatus: enums.TransitStatus.nullish(),
    legacyCost: numStr.nullish(),
    handlingCharge: z.string().nullish(),
    transportationCharge: z.string().nullish(),
    advanceAmount: z.string().nullish(),
    qualityCheckStatus: enums.QualityCheckStatus.nullish(),
    numBags: z.number().nullish(),
    avgPricePerBatch: numStr.nullish(),
    avgPricePerKg: numStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    numExpectedBatches: z.number().nullish(),
    batchSize: z.number().nullish(),
    weightDispatchedKg: numStr.nullish(),
    numBatchesDispatched: z.number().nullish(),
    weightDeliveredKg: numStr.nullish(),
    numBatchesDelivered: z.number().nullish(),
    produceTypeId: posIntStr.nullish(),
    produceTypeKey: z.string().nullish(),
    varietyId: posIntStr.nullish(),
    varietyKey: z.string().nullish(),
    ingressStopId: posIntStr.nullish(),
    ingressStopName: z.string().nullish(),
    ingressClusterId: posIntStr.nullish(),
    ingressClusterName: z.string().nullish(),
    ingressBlockId: posIntStr.nullish(),
    ingressBlockName: z.string().nullish(),
    ingressDistrictId: posIntStr.nullish(),
    ingressDistrictName: z.string().nullish(),
    ingressRegionId: posIntStr.nullish(),
    ingressRegionName: z.string().nullish(),
    buyerOrderId: posIntStr.nullish(),
    buyerOrderPubId: z.string().nullish(),
    buyerId: posIntStr.nullish(),
    buyerPubId: z.string().nullish(),
    buyerFullName: z.string().nullish(),
    deliveryAddressId: posIntStr.nullish(),
    cancellerId: posIntStr.nullish(),
    cancellerFullName: z.string().nullish(),
    vehicleOwnerId: posIntStr.nullish(),
    vehicleOwnerFullName: z.string().nullish(),
    vehicleDriverId: posIntStr.nullish(),
    vehicleDriverFullName: z.string().nullish(),
    transporterId: posIntStr.nullish(),
    transporterFullName: z.string().nullish(),
    qualityCheckerId: posIntStr.nullish(),
    qualityCheckerFullName: z.string().nullish(),
    shipmentItemId: posIntStr,
    amount: numStr.nullish(),
});
export const ReportingShipmentDetailsUpdate = z
    .object({
    shipmentId: posIntStr,
    expectedDispatchSlotStart: msseDate.nullish(),
    dispatchedAt: msseDate.nullish(),
    expectedToDeliverAt: msseDate.nullish(),
    deliveredAt: msseDate.nullish(),
    pubId: z.string().nullish(),
    createdAt: msseDate.nullish(),
    transitStatus: enums.TransitStatus.nullish(),
    legacyCost: numStr.nullish(),
    handlingCharge: z.string().nullish(),
    transportationCharge: z.string().nullish(),
    advanceAmount: z.string().nullish(),
    qualityCheckStatus: enums.QualityCheckStatus.nullish(),
    numBags: z.number().nullish(),
    avgPricePerBatch: numStr.nullish(),
    avgPricePerKg: numStr.nullish(),
    expectedWeightKg: numStr.nullish(),
    numExpectedBatches: z.number().nullish(),
    batchSize: z.number().nullish(),
    weightDispatchedKg: numStr.nullish(),
    numBatchesDispatched: z.number().nullish(),
    weightDeliveredKg: numStr.nullish(),
    numBatchesDelivered: z.number().nullish(),
    produceTypeId: posIntStr.nullish(),
    produceTypeKey: z.string().nullish(),
    varietyId: posIntStr.nullish(),
    varietyKey: z.string().nullish(),
    ingressStopId: posIntStr.nullish(),
    ingressStopName: z.string().nullish(),
    ingressClusterId: posIntStr.nullish(),
    ingressClusterName: z.string().nullish(),
    ingressBlockId: posIntStr.nullish(),
    ingressBlockName: z.string().nullish(),
    ingressDistrictId: posIntStr.nullish(),
    ingressDistrictName: z.string().nullish(),
    ingressRegionId: posIntStr.nullish(),
    ingressRegionName: z.string().nullish(),
    buyerOrderId: posIntStr.nullish(),
    buyerOrderPubId: z.string().nullish(),
    buyerId: posIntStr.nullish(),
    buyerPubId: z.string().nullish(),
    buyerFullName: z.string().nullish(),
    deliveryAddressId: posIntStr.nullish(),
    cancellerId: posIntStr.nullish(),
    cancellerFullName: z.string().nullish(),
    vehicleOwnerId: posIntStr.nullish(),
    vehicleOwnerFullName: z.string().nullish(),
    vehicleDriverId: posIntStr.nullish(),
    vehicleDriverFullName: z.string().nullish(),
    transporterId: posIntStr.nullish(),
    transporterFullName: z.string().nullish(),
    qualityCheckerId: posIntStr.nullish(),
    qualityCheckerFullName: z.string().nullish(),
    shipmentItemId: posIntStr,
    amount: numStr.nullish(),
})
    .partial();
export const ReportingSoilTestingBookingDetails = z.object({
    bookingId: posIntStr,
    bookingPubId: z.string().nullish(),
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    testId: posIntStr.nullish(),
    testName: z.string().nullish(),
    vendorName: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    status: z.string().nullish(),
    bookingDate: msse.nullish(),
    requestedAt: msse.nullish(),
    completedAt: msse.nullish(),
    collectedAt: msse.nullish(),
});
export const NewReportingSoilTestingBookingDetails = z.object({
    bookingId: posIntStr,
    bookingPubId: z.string().nullish(),
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    testId: posIntStr.nullish(),
    testName: z.string().nullish(),
    vendorName: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    status: z.string().nullish(),
    bookingDate: msseDate.nullish(),
    requestedAt: msseDate.nullish(),
    completedAt: msseDate.nullish(),
    collectedAt: msseDate.nullish(),
});
export const ReportingSoilTestingBookingDetailsUpdate = z
    .object({
    bookingId: posIntStr,
    bookingPubId: z.string().nullish(),
    userId: posIntStr.nullish(),
    userPubId: z.string().nullish(),
    userFullName: z.string().nullish(),
    userPhone: z.string().nullish(),
    testId: posIntStr.nullish(),
    testName: z.string().nullish(),
    vendorName: z.string().nullish(),
    clusterId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterRegionName: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    status: z.string().nullish(),
    bookingDate: msseDate.nullish(),
    requestedAt: msseDate.nullish(),
    completedAt: msseDate.nullish(),
    collectedAt: msseDate.nullish(),
})
    .partial();
export const ReportingUserDetails = z.object({
    userId: posIntStr,
    lastLoginAt: msse.nullish(),
    pubId: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    state: z.string().nullish(),
    district: z.string().nullish(),
    cityOrVillage: z.string().nullish(),
    postOffice: z.string().nullish(),
    pinCode: z.string().nullish(),
    lastBuyerOrderAt: msse.nullish(),
    lastSellerOrderAt: msse.nullish(),
    clusterId: posIntStr.nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionName: z.string().nullish(),
    sysRoleNames: z.string().nullish(),
    registeredAt: msse.nullish(),
    isInternal: z.boolean().nullish(),
    fullName: z.string().nullish(),
    dob: msse.nullish(),
    cohorts: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    hasBeneficiary: z.boolean().nullish(),
    hasApprovedBeneficiary: z.boolean().nullish(),
    totalPaymentReceived: z.boolean().nullish(),
    totalOnlinePaymentReceived: z.boolean().nullish(),
    firstPaymentReceivedAt: msse.nullish(),
    lastPaymentReceivedAt: msse.nullish(),
    transactedBeneficiaryCount: z.number().nullish(),
    approvedBeneficiaryCount: z.number().nullish(),
});
export const NewReportingUserDetails = z.object({
    userId: posIntStr,
    lastLoginAt: msseDate.nullish(),
    pubId: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    state: z.string().nullish(),
    district: z.string().nullish(),
    cityOrVillage: z.string().nullish(),
    postOffice: z.string().nullish(),
    pinCode: z.string().nullish(),
    lastBuyerOrderAt: msseDate.nullish(),
    lastSellerOrderAt: msseDate.nullish(),
    clusterId: posIntStr.nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionName: z.string().nullish(),
    sysRoleNames: z.string().nullish(),
    registeredAt: msseDate.nullish(),
    isInternal: z.boolean().nullish(),
    fullName: z.string().nullish(),
    dob: msseDate.nullish(),
    cohorts: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    hasBeneficiary: z.boolean().nullish(),
    hasApprovedBeneficiary: z.boolean().nullish(),
    totalPaymentReceived: z.boolean().nullish(),
    totalOnlinePaymentReceived: z.boolean().nullish(),
    firstPaymentReceivedAt: msseDate.nullish(),
    lastPaymentReceivedAt: msseDate.nullish(),
    transactedBeneficiaryCount: z.number().nullish(),
    approvedBeneficiaryCount: z.number().nullish(),
});
export const ReportingUserDetailsUpdate = z
    .object({
    userId: posIntStr,
    lastLoginAt: msseDate.nullish(),
    pubId: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    state: z.string().nullish(),
    district: z.string().nullish(),
    cityOrVillage: z.string().nullish(),
    postOffice: z.string().nullish(),
    pinCode: z.string().nullish(),
    lastBuyerOrderAt: msseDate.nullish(),
    lastSellerOrderAt: msseDate.nullish(),
    clusterId: posIntStr.nullish(),
    clusterRegionId: posIntStr.nullish(),
    clusterName: z.string().nullish(),
    clusterRegionName: z.string().nullish(),
    sysRoleNames: z.string().nullish(),
    registeredAt: msseDate.nullish(),
    isInternal: z.boolean().nullish(),
    fullName: z.string().nullish(),
    dob: msseDate.nullish(),
    cohorts: z.string().nullish(),
    clusterDistrictId: posIntStr.nullish(),
    clusterDistrictName: z.string().nullish(),
    clusterBlockId: posIntStr.nullish(),
    clusterBlockName: z.string().nullish(),
    hasBeneficiary: z.boolean().nullish(),
    hasApprovedBeneficiary: z.boolean().nullish(),
    totalPaymentReceived: z.boolean().nullish(),
    totalOnlinePaymentReceived: z.boolean().nullish(),
    firstPaymentReceivedAt: msseDate.nullish(),
    lastPaymentReceivedAt: msseDate.nullish(),
    transactedBeneficiaryCount: z.number().nullish(),
    approvedBeneficiaryCount: z.number().nullish(),
})
    .partial();
export const ReportingUserDeviceUsed = z.object({
    numUsers: z.number().nullish(),
    deviceType: z.string(),
});
export const NewReportingUserDeviceUsed = z.object({
    numUsers: z.number().nullish(),
    deviceType: z.string(),
});
export const ReportingUserDeviceUsedUpdate = z
    .object({
    numUsers: z.number().nullish(),
    deviceType: z.string(),
})
    .partial();
export const ScraperArticleEvaluation = z.object({
    id: posIntStr,
    title: z.string(),
    url: z.string(),
    response: z.any(),
    updatedAt: msse.nullish(),
});
export const NewScraperArticleEvaluation = z.object({
    title: z.string(),
    url: z.string(),
    response: z.any(),
});
export const ScraperArticleEvaluationUpdate = z
    .object({
    title: z.string(),
    url: z.string(),
    response: z.any(),
})
    .partial();
export const ScraperArticleRelevance = z.object({
    id: posIntStr,
    articleId: posIntStr,
    region: z.string(),
    evaluation: z.string(),
    updatedAt: msse.nullish(),
});
export const NewScraperArticleRelevance = z.object({
    articleId: posIntStr,
    region: z.string(),
    evaluation: z.string(),
});
export const ScraperArticleRelevanceUpdate = z
    .object({
    articleId: posIntStr,
    region: z.string(),
    evaluation: z.string(),
})
    .partial();
export const ScraperScrapedUrl = z.object({
    id: posIntStr,
    url: z.string(),
    title: z.string().nullish(),
    scrapedAt: msse.nullish(),
    status: z.any(),
    docPath: z.string().nullish(),
    articleMetadata: z.any().nullish(),
    targetSourceId: posIntStr.nullish(),
    cropTags: z.string(),
    regionTags: z.string(),
    contentCategory: z.any().nullish(),
    curatorNotes: z.string().nullish(),
});
export const NewScraperScrapedUrl = z.object({
    url: z.string(),
    title: z.string().nullish(),
    scrapedAt: msseDate.nullish(),
    status: z.any().nullish(),
    docPath: z.string().nullish(),
    articleMetadata: z.any().nullish(),
    targetSourceId: posIntStr.nullish(),
    cropTags: z.string().nullish(),
    regionTags: z.string().nullish(),
    contentCategory: z.any().nullish(),
    curatorNotes: z.string().nullish(),
});
export const ScraperScrapedUrlUpdate = z
    .object({
    url: z.string(),
    title: z.string().nullish(),
    scrapedAt: msseDate.nullish(),
    status: z.any(),
    docPath: z.string().nullish(),
    articleMetadata: z.any().nullish(),
    targetSourceId: posIntStr.nullish(),
    cropTags: z.string(),
    regionTags: z.string(),
    contentCategory: z.any().nullish(),
    curatorNotes: z.string().nullish(),
})
    .partial();
export const ScraperSearchEngine = z.object({
    key: z.string(),
    urlFormat: z.string(),
    resultContainerSelector: z.string().nullish(),
    titleSelector: z.string().nullish(),
    descriptionSelector: z.string().nullish(),
    urlSelector: z.string().nullish(),
    lastSearchedAt: msse.nullish(),
});
export const NewScraperSearchEngine = z.object({
    key: z.string(),
    urlFormat: z.string(),
    resultContainerSelector: z.string().nullish(),
    titleSelector: z.string().nullish(),
    descriptionSelector: z.string().nullish(),
    urlSelector: z.string().nullish(),
    lastSearchedAt: msseDate.nullish(),
});
export const ScraperSearchEngineUpdate = z
    .object({
    key: z.string(),
    urlFormat: z.string(),
    resultContainerSelector: z.string().nullish(),
    titleSelector: z.string().nullish(),
    descriptionSelector: z.string().nullish(),
    urlSelector: z.string().nullish(),
    lastSearchedAt: msseDate.nullish(),
})
    .partial();
export const ScraperSearchResult = z.object({
    id: posIntStr,
    topicId: posIntStr,
    sessionId: z.string(),
    order: z.number(),
    url: z.string(),
    title: z.string().nullish(),
    description: z.string().nullish(),
    createdAt: msse,
    analyzedAt: msse.nullish(),
    details: z.any().nullish(),
    relevanceScore: z.number().nullish(),
    contentKeyPath: z.string().nullish(),
});
export const NewScraperSearchResult = z.object({
    topicId: posIntStr,
    sessionId: z.string(),
    order: z.number(),
    url: z.string(),
    title: z.string().nullish(),
    description: z.string().nullish(),
    createdAt: msseDate.nullish(),
    analyzedAt: msseDate.nullish(),
    details: z.any().nullish(),
    relevanceScore: z.number().nullish(),
    contentKeyPath: z.string().nullish(),
});
export const ScraperSearchResultUpdate = z
    .object({
    topicId: posIntStr,
    sessionId: z.string(),
    order: z.number(),
    url: z.string(),
    title: z.string().nullish(),
    description: z.string().nullish(),
    createdAt: msseDate,
    analyzedAt: msseDate.nullish(),
    details: z.any().nullish(),
    relevanceScore: z.number().nullish(),
    contentKeyPath: z.string().nullish(),
})
    .partial();
export const ScraperSearchTopic = z.object({
    id: posIntStr,
    topic: z.string(),
    lastSearchedAt: msse.nullish(),
    isEnabled: z.boolean(),
});
export const NewScraperSearchTopic = z.object({
    topic: z.string(),
    lastSearchedAt: msseDate.nullish(),
    isEnabled: z.boolean().nullish(),
});
export const ScraperSearchTopicUpdate = z
    .object({
    topic: z.string(),
    lastSearchedAt: msseDate.nullish(),
    isEnabled: z.boolean(),
})
    .partial();
export const ScraperSuggestedTopics = z.object({
    id: z.string(),
    category: z.any(),
    domain: z.any(),
    signalType: z.any(),
    title: z.string(),
    insight: z.string(),
    whyInteresting: z.string(),
    compositeScore: numStr,
    targetRegions: z.string(),
    targetCrops: z.string(),
    targetDasMin: z.number().nullish(),
    targetDasMax: z.number().nullish(),
    validUntil: msse,
    discoveredAt: msse,
    meta: z.any(),
});
export const NewScraperSuggestedTopics = z.object({
    category: z.any(),
    domain: z.any(),
    signalType: z.any(),
    title: z.string(),
    insight: z.string(),
    whyInteresting: z.string(),
    compositeScore: numStr,
    targetRegions: z.string().nullish(),
    targetCrops: z.string().nullish(),
    targetDasMin: z.number().nullish(),
    targetDasMax: z.number().nullish(),
    validUntil: msseDate,
    discoveredAt: msseDate.nullish(),
    meta: z.any().nullish(),
});
export const ScraperSuggestedTopicsUpdate = z
    .object({
    category: z.any(),
    domain: z.any(),
    signalType: z.any(),
    title: z.string(),
    insight: z.string(),
    whyInteresting: z.string(),
    compositeScore: numStr,
    targetRegions: z.string(),
    targetCrops: z.string(),
    targetDasMin: z.number().nullish(),
    targetDasMax: z.number().nullish(),
    validUntil: msseDate,
    discoveredAt: msseDate,
    meta: z.any(),
})
    .partial();
export const ScraperTargetSource = z.object({
    id: posIntStr,
    key: z.string(),
    url: z.string(),
    isActive: z.boolean().nullish(),
    skipPatterns: z.string().nullish(),
    sourceType: z.any(),
    domain: z.any(),
    cropTags: z.string(),
    regionTags: z.string(),
    refetchTtl: z.number().nullish(),
    lastFetchedAt: msse.nullish(),
    notes: z.string().nullish(),
    config: z.any(),
});
export const NewScraperTargetSource = z.object({
    key: z.string(),
    url: z.string(),
    isActive: z.boolean().nullish(),
    skipPatterns: z.string().nullish(),
    sourceType: z.any().nullish(),
    domain: z.any().nullish(),
    cropTags: z.string().nullish(),
    regionTags: z.string().nullish(),
    refetchTtl: z.number().nullish(),
    lastFetchedAt: msseDate.nullish(),
    notes: z.string().nullish(),
    config: z.any().nullish(),
});
export const ScraperTargetSourceUpdate = z
    .object({
    key: z.string(),
    url: z.string(),
    isActive: z.boolean().nullish(),
    skipPatterns: z.string().nullish(),
    sourceType: z.any(),
    domain: z.any(),
    cropTags: z.string(),
    regionTags: z.string(),
    refetchTtl: z.number().nullish(),
    lastFetchedAt: msseDate.nullish(),
    notes: z.string().nullish(),
    config: z.any(),
})
    .partial();
//# sourceMappingURL=internal.js.map